import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import moment from 'moment';
import { cloneDeep, debounce } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ResultService = /** @class */ (function () {
    function ResultService(http) {
        var _this = this;
        this.http = http;
        this.analyticsEndPoint = '/dashboard/smtanalytics/v1';
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this.dateRangeOptions = [{
                duration: '3D',
                step: 'day',
                text: 'Last 3 days'
            }, {
                duration: '7D',
                step: 'day',
                text: 'Last 7 days'
            }, {
                duration: '1M',
                step: 'day',
                text: 'Last 30 days'
            }, {
                duration: '3M',
                step: 'day',
                text: 'Last 3 months'
            }];
        this.propertyWiseResultTableMapOfABNode = {
            branch: {
                conversion: {
                    header: [
                        {
                            title: 'Variant',
                            colWidth: '30%',
                        },
                        {
                            title: 'Variant population'
                        },
                        {
                            title: 'Goal performing users'
                        },
                        {
                            title: 'Variation from control group',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This metric represents percentage difference variant data compared to the control group data.',
                                }]
                        }
                    ],
                    columnCount: 4
                },
                generic: {
                    header: [
                        {
                            title: 'Variant',
                            colWidth: '30%',
                        },
                        {
                            title: 'Variant population'
                        },
                        {
                            title: 'Goal performing users'
                        },
                        {
                            title: 'Total goal events',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'These are total number of goal events performed by the users who fall in the given variant. ',
                                }]
                        },
                        {
                            title: 'Variation from control group',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This metric represents percentage difference variant data compared to the control group data.',
                                }]
                        }
                    ],
                    columnCount: 5
                },
                sum: {
                    header: [
                        {
                            title: 'Variant',
                            colWidth: '30%',
                        },
                        {
                            title: 'Variant population'
                        },
                        {
                            title: 'Goal performing users'
                        },
                        {
                            title: 'Sum of goal event property',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This is the sum value of a property for all goal events performed by the users who fall int he given variant.',
                                }]
                        },
                        {
                            title: 'Variation from control group',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This metric represents percentage difference variant data compared to the control group data.',
                                }]
                        }
                    ],
                    columnCount: 5
                }
            },
            nudge: {
                conversion: {
                    header: [
                        {
                            title: 'Variant',
                            colWidth: '30%',
                        },
                        {
                            title: 'Variant population'
                        },
                        {
                            title: 'Unique trigger events'
                        },
                        {
                            title: 'Unique views'
                        },
                        {
                            title: 'Attributed users',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'These are unique users who have seen the nudge and also performed the goal event within the attribution window. This count is simulated for the users in the control group of A/B experiment.',
                                }]
                        },
                        {
                            title: 'Variation from control group',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This metric represents percentage difference variant data compared to the control group data.',
                                }]
                        }
                    ],
                    columnCount: 6
                },
                generic: {
                    header: [
                        {
                            title: 'Variant',
                            colWidth: '30%',
                        },
                        {
                            title: 'Variant population'
                        },
                        {
                            title: 'Unique trigger events'
                        },
                        {
                            title: 'Unique views'
                        },
                        {
                            title: 'Attributed users',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'These are unique users who have seen the nudge and also performed the goal event within the attribution window. This count is simulated for the users in the control group of A/B experiment.',
                                }]
                        },
                        {
                            title: 'Attributed events',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'These are total number of goal events performed by the users who have seen the nudge and also performed the goal event within the attribution window. This count is simulated for the users in the control group of A/B experiment.',
                                }]
                        },
                        {
                            title: 'Variation from control group',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This metric represents percentage difference variant data compared to the control group data.',
                                }]
                        }
                    ],
                    columnCount: 7
                },
                sum: {
                    header: [
                        {
                            title: 'Variant',
                            colWidth: '30%',
                        },
                        {
                            title: 'Variant population'
                        },
                        {
                            title: 'Unique trigger events'
                        },
                        {
                            title: 'Unique views'
                        },
                        {
                            title: 'Attributed users',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'These are unique users who have seen the nudge and also performed the goal event within the attribution window. This count is simulated for the users in the control group of A/B experiment.',
                                }]
                        },
                        {
                            title: 'Attributed sum of event property',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This is the sum value of a property for all the goal events performed by the users who have seen the nudge within the attribution window. This count is simulated for the users in the control group of A/B experiment. ',
                                }]
                        },
                        {
                            title: 'Variation from control group',
                            iconDetails: [{
                                    key: 'tooltip',
                                    tooltipIconsText: 'This metric represents percentage difference variant data compared to the control group data.',
                                }]
                        }
                    ],
                    columnCount: 7
                }
            }
        };
        this.propertyWiseResultTableMapOfDisplayNudges = {
            conversion: {
                header: [
                    {
                        title: 'Variant',
                        colWidth: '30%',
                    },
                    {
                        title: 'Segment population'
                    },
                    {
                        title: 'Unique trigger events'
                    },
                    {
                        title: 'Unique views'
                    },
                    {
                        title: 'Attributed users',
                        iconDetails: [{
                                key: 'tooltip',
                                tooltipIconsText: 'These are unique users who have seen the nudge and also performed the goal event within the attribution window. For users in the control group of A/B experiment, this is a simulated count.',
                            }]
                    }
                ],
                columnCount: 5
            },
            generic: {
                header: [
                    {
                        title: 'Variant',
                        colWidth: '30%',
                    },
                    {
                        title: 'Segment population'
                    },
                    {
                        title: 'Unique trigger events'
                    },
                    {
                        title: 'Unique views'
                    },
                    {
                        title: 'Attributed users',
                        iconDetails: [{
                                key: 'tooltip',
                                tooltipIconsText: 'These are unique users who have seen the nudge and also performed the goal event within the attribution window. For users in the control group of A/B experiment, this is a simulated count.',
                            }]
                    },
                    {
                        title: 'Attributed events',
                        iconDetails: [{
                                key: 'tooltip',
                                tooltipIconsText: 'These are total number of goal events performed by the users who have seen the nudge and also performed the goal event within the attribution window. For users in the control group of A/B experiment, this is a simulated count.',
                            }]
                    }
                ],
                columnCount: 6
            },
            sum: {
                header: [
                    {
                        title: 'Variant',
                        colWidth: '30%',
                    },
                    {
                        title: 'Segment population'
                    },
                    {
                        title: 'Unique trigger events'
                    },
                    {
                        title: 'Unique views'
                    },
                    {
                        title: 'Attributed users',
                        iconDetails: [{
                                key: 'tooltip',
                                tooltipIconsText: 'These are unique users who have seen the nudge and also performed the goal event within the attribution window. For users in the control group of A/B experiment, this is a simulated count.',
                            }]
                    },
                    {
                        title: 'Sum of event property for attributed users',
                        iconDetails: [{
                                key: 'tooltip',
                                tooltipIconsText: 'This is the sum of values of a property for the goal event performed by the users who have seen the nudge and also performed the goal event within the attribution window. For users in the control group of A/B experiment, this is a simulated count.',
                            }]
                    }
                ],
                columnCount: 6
            }
        };
        this.resultTableMapForNonGoalNudgeOrBranch = {
            header: [
                {
                    title: 'Variant',
                    colWidth: '30%',
                },
                {
                    title: 'Segment population'
                }
            ]
        };
        this.diagnosisResultTableMap = {
            header: [
                {
                    title: 'Nudge',
                    colWidth: '30%',
                },
                {
                    title: 'Segment population'
                },
                {
                    title: 'Unique trigger events'
                },
                {
                    title: 'Users not nudged',
                    iconDetails: [{
                            key: 'tooltip',
                            tooltipIconsText: 'Unique users who have not viewed the nudge. Count for control group users of A/B testing is simulated.',
                        }]
                }
            ],
            columnCount: 4
        };
        this.nudgeNotShownResultTable = {
            header: [
                {
                    title: 'Variant',
                    colWidth: '15%',
                    align: 'center'
                },
                {
                    title: 'Count',
                    colWidth: '15%',
                    align: 'center'
                },
                {
                    title: 'Impact',
                    colWidth: '15%',
                    align: 'center'
                },
                {
                    title: 'Interpretation',
                    align: 'left'
                }
            ]
        };
        this.columnIndexOfBranchCount = {
            ab_exp_node: {
                conversion: 1,
                generic: 1,
                sum: 1
            },
            prompt: {
                conversion: 1,
                generic: 1,
                sum: 1
            }
        };
        this.columnIndexOfPromptCount = {
            ab_exp_node: {
                conversion: 3,
                generic: 3,
                sum: 3
            },
            prompt: {
                conversion: 3,
                generic: 3,
                sum: 3
            }
        };
        this.columnIndexOfGoalCount = {
            ab_exp_node: {
                branch_level: {
                    conversion: [2],
                    generic: [2, 3],
                    sum: [2, 3]
                },
                nudge_level: {
                    conversion: [4],
                    generic: [4, 5],
                    sum: [4, 5]
                }
            },
            prompt: {
                conversion: [4],
                generic: [4, 5],
                sum: [4, 5]
            }
        };
        this.columnIndexOfTriggerCount = {
            ab_exp_node: 2,
            prompt: 2,
            diagnosis: 2
        };
        this.columnIndexOfNudgeNotShownCount = 3;
        this.reportResultData = new Subject();
        this.feedbackSummaryGeneration = new Subject();
        this.reportDataHeaderForNudges = {
            header: ['Journey', 'Nudge', 'Total Views', 'Unique Views', 'Dismissed']
        };
        this.reportDataHeaderForBranches = {
            header: ['Journey', 'Branch', 'Goal']
        };
        this.setReportResultData = debounce(function (data) {
            _this.reportResultData.next(data);
        }, 100);
        this.generateFeedbackSummaryReport = debounce(function () {
            _this.feedbackSummaryGeneration.next();
        }, 100);
    }
    ResultService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    ResultService.prototype.getDateRangeOptions = function () {
        return this.dateRangeOptions;
    };
    /**
     * method returns an object containing start and end date between given duration
     * @param duration string, number of days you want to subtract
     * @param addExtraDay boolean, optional. pass true if you want date to start from tomorrow
     * @returns object
     */
    ResultService.prototype.getStartAndEndTime = function (duration, addExtraDay) {
        var end, start, tomorrow, date;
        end = moment().utc().startOf('day');
        if (addExtraDay) {
            // modify end date while populating the chart labels
            end = end.add(moment.duration('P1D')).startOf('day');
            date = end;
        }
        else {
            // use tomorrow to get the start date for all the APIs
            tomorrow = moment().utc().add(moment.duration('P1D')).startOf('day');
            date = tomorrow;
        }
        start = moment(date).subtract(moment.duration('P' + duration));
        return ({ start: start, end: end });
    };
    ResultService.prototype.getBranchCounts = function (payload) {
        var endPoint = this.analyticsEndPoint + "/branch/counts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.getGoalCounts = function (payload) {
        var endPoint = this.analyticsEndPoint + "/goal/counts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
        // return of(this.returnDummyResponse(payload));
    };
    ResultService.prototype.getDays = function (startDate, endDate) {
        var days = [];
        var momentStartDate = moment(startDate, 'DD/MM/YYYY');
        var momentEndDate = moment(endDate, 'DD/MM/YYYY');
        while (!momentStartDate.isSame(momentEndDate)) {
            days.push(momentStartDate.format('DD/MM/YYYY'));
            momentStartDate.add(1, 'day');
        }
        return days;
    };
    ResultService.prototype.getGoalCharts = function (payload) {
        var endPoint = this.analyticsEndPoint + "/goal/charts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.getPromptCounts = function (payload) {
        var endPoint = this.analyticsEndPoint + "/prompt/counts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.getABNodeTableHeaderForEventProperty = function (property, resultType) {
        return this.propertyWiseResultTableMapOfABNode[resultType][property];
    };
    ResultService.prototype.getDisplayNudgeTableHeaderForEventProperty = function (property) {
        return this.propertyWiseResultTableMapOfDisplayNudges[property];
    };
    ResultService.prototype.getTableHeaderForNonGoalNudgeOrBranch = function () {
        return this.resultTableMapForNonGoalNudgeOrBranch;
    };
    ResultService.prototype.getTableHeaderForNudgeNotShown = function () {
        return this.nudgeNotShownResultTable;
    };
    ResultService.prototype.getColumnIndexOfBranchCounts = function (property, isABNode) {
        if (isABNode) {
            return this.columnIndexOfBranchCount.ab_exp_node[property];
        }
        return this.columnIndexOfBranchCount.prompt[property];
    };
    ResultService.prototype.getColumnIndexOfPromptCounts = function (property, isABNode) {
        if (isABNode) {
            return this.columnIndexOfPromptCount.ab_exp_node[property];
        }
        return this.columnIndexOfPromptCount.prompt[property];
    };
    ResultService.prototype.getColumnIndexOfGoalCounts = function (property, level, isABNode) {
        if (isABNode) {
            return this.columnIndexOfGoalCount.ab_exp_node[level][property];
        }
        return this.columnIndexOfGoalCount.prompt[property];
    };
    ResultService.prototype.getColumnIndexOfTriggerCounts = function (type) {
        if (type === 'ab_exp_node') {
            return this.columnIndexOfTriggerCount.ab_exp_node;
        }
        else if (type === 'prompt') {
            return this.columnIndexOfTriggerCount.prompt;
        }
        return this.columnIndexOfTriggerCount.diagnosis;
    };
    ResultService.prototype.getColumnIndexOfNudgeNotShownCounts = function () {
        return this.columnIndexOfNudgeNotShownCount;
    };
    ResultService.prototype.generateVariantsName = function (noOfVariants) {
        var list = [];
        for (var i = 0; i < noOfVariants; i++) {
            if (i === 0) {
                list.push('Control Group');
            }
            else {
                list.push("Variant " + i);
            }
        }
        return list;
    };
    ResultService.prototype.generateXAxesLables = function (startTime, endTime, step) {
        if (step === void 0) { step = 'day'; }
        var start = moment(startTime).local();
        var end = moment(endTime).local();
        var timeSeries = [];
        for (; end.diff(start, 'days'); start.add(1, step)) {
            timeSeries.push(start.format('MMM DD'));
        }
        return timeSeries;
    };
    ResultService.prototype.getFeedbackNudgeResult = function (payload) {
        var endPoint = this.analyticsEndPoint + "/prompt/charts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.getDiagnosisTableHeader = function () {
        return this.diagnosisResultTableMap;
    };
    ResultService.prototype.toFixed = function (num, fixed) {
        return Number.parseFloat(num.toFixed(fixed));
    };
    ResultService.prototype.getReportDataHeaderForNudges = function () {
        return this.reportDataHeaderForNudges.header;
    };
    ResultService.prototype.getReportDataHeaderForBranches = function () {
        return this.reportDataHeaderForBranches.header;
    };
    ResultService.prototype.processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            }
            ;
            var result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0) {
                result = '"' + result + '"';
            }
            if (j > 0) {
                finalVal += ',';
            }
            finalVal += result;
        }
        return finalVal + '\n';
    };
    ;
    ResultService.prototype.exportToCsv = function (filename, rows) {
        var csvFile = '';
        for (var i = 0; i < rows.length; i++) {
            csvFile += this.processRow(rows[i]);
        }
        var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    ResultService.prototype.getReportData = function (metaData) {
        var header = cloneDeep(this.getReportDataHeaderForBranches());
        var body = [], row = [];
        var title = metaData.title;
        var fileName = title + " - " + moment(metaData.time.start).format("DD MMM'YY") + "_" + moment(metaData.time.end).format("DD MMM'YY") + ".csv";
        row.push(metaData.interactionMapName);
        row.push(metaData.headerTitle);
        row.push(metaData.eventName);
        return {
            header: header,
            body: body,
            row: row,
            fileName: fileName
        };
    };
    ResultService.prototype.getAttrCount = function (payload) {
        var endPoint = "/dashboard/v1/hansel/results/nudge-attribution";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.fetchTriggerCount = function (payload) {
        var endPoint = this.analyticsEndPoint + "/trigger/counts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.fetchNudgeNotShownCount = function (payload) {
        var endPoint = this.analyticsEndPoint + "/not-shown/counts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.fetchNudgeNotShownReasonCount = function (payload) {
        var endPoint = this.analyticsEndPoint + "/not-shown/reason/counts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.fetchNudgeNotShownReasonChart = function (payload) {
        var endPoint = this.analyticsEndPoint + "/not-shown/charts";
        return this.http.post(endPoint, payload, this.httpOptions).pipe(map(this.extractData));
    };
    ResultService.prototype.getConversionData = function (data) {
        if (!data.hasOwnProperty('tuc')) {
            return 0;
        }
        return data.tuc;
    };
    ResultService.prototype.getEmptyRow = function (len) {
        if (!len) {
            return [''];
        }
        var arr = [];
        for (var i = 0; i < len; i++) {
            arr.push('');
        }
        return arr;
    };
    ResultService.prototype.populateBodyWithConversionData = function (body, row, conversionDataMap, label) {
        // push conversion count only for Conversion event type
        if (label === 'conversion') {
            // push empty row
            body.push(this.getEmptyRow(row.length));
            body.push(['Conversions']);
            body.push(conversionDataMap.header);
            body.push(conversionDataMap.conversions);
        }
        // push empty row
        body.push(this.getEmptyRow(row.length));
        body.push(['Event Count']);
        body.push(conversionDataMap.header);
        body.push(conversionDataMap.eventCount);
    };
    ResultService.prototype.populateRowWithHeaderData = function (body, headerData) {
        var row = [];
        headerData.forEach(function (header) { return row.push(header.title); });
        body.push(row);
    };
    ResultService.prototype.getExpStackOfNode = function (statements) {
        if (statements.hasOwnProperty('decision_node')) {
            return statements.decision_node.exp_stack;
        }
        else if (statements.hasOwnProperty('rollout_node')) {
            return statements.rollout_node.exp_stack;
        }
        else if (statements.hasOwnProperty('ab_exp_node')) {
            return statements.ab_exp_node.exp_stack;
        }
        else {
            return statements.leaf_node.exp_stack;
        }
    };
    ResultService.prototype.generateVariantsNameForNudges = function (ab_exp_node) {
        var _this = this;
        var list = [];
        ab_exp_node.split.forEach(function (spiltItem, splitIndex) {
            if (splitIndex === 0) {
                list.push('Control Group');
            }
            else {
                var exp_stack = _this.getExpStackOfNode(spiltItem.statements[0]);
                if (exp_stack.length) {
                    list.push("Variant " + splitIndex);
                }
            }
        });
        return list;
    };
    // below method returns dummy response for given array of ids
    ResultService.prototype.returnDummyResponse = function (payload, type) {
        var ids;
        if (payload.resource_ids) {
            ids = payload.resource_ids;
        }
        else if (payload.prompt_ids) {
            ids = payload.prompt_ids;
        }
        else {
            ids = payload.branch_ids;
        }
        var res = {
            "error_type": "",
            "is_error": false,
            "error_message": "",
            "api_response": {
                "tz": "Asia/Calcutta",
            }
        };
        var data = {};
        for (var i = 0; i < ids.length; i++) {
            data[ids[i]] = {
                totalUniqueCount: Math.floor(Math.random() * 1000000)
            };
            if (type === 'promptCount') {
                data[ids[i]]['button1ClicksCount'] = Math.floor(Math.random() * 1000000);
                data[ids[i]]['button2ClicksCount'] = Math.floor(Math.random() * 1000000);
            }
            if (payload.goal) {
                if (payload.goal.type.label === 'generic') {
                    data[ids[i]]['totalTotalCount'] = Math.floor(Math.random() * 1000000);
                }
                else if (payload.goal.type.label === 'sum') {
                    data[ids[i]]['totalCountSum'] = Math.floor(Math.random() * 1000000);
                }
            }
        }
        res['api_response']['data'] = data;
        return res;
    };
    ResultService.ngInjectableDef = i0.defineInjectable({ factory: function ResultService_Factory() { return new ResultService(i0.inject(i1.HttpClient)); }, token: ResultService, providedIn: "root" });
    return ResultService;
}());
export { ResultService };
